import React from "react"

import { Input } from "@/components/ui/input"
import { TrialBlock } from "@/types/trialBlock"

interface TrialBlockInfoProps {
  shift: TrialBlock
}

const TrialBlockInfo: React.FC<TrialBlockInfoProps> = ({ shift }) => {
  return (
    <div className="grid grid-cols-2 gap-4 bg-palette-jungleGreen000 p-4 rounded-md">
      <div>
        <label className="block text-sm font-medium mb-1">Driver Name</label>
        <Input value={shift.driverName} disabled className="bg-white" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Applied Position</label>
        <Input value={shift.position} disabled className="bg-white" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Route Code</label>
        <Input value={shift.routeCode} disabled className="bg-white" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Route Cycle</label>
        <Input value={shift.routeCycle} disabled className="bg-white" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Vehicle Name</label>
        <Input value={shift.vehicleName} disabled className="bg-white" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Location</label>
        <Input value={shift.location} disabled className="bg-white" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Date</label>
        <Input value={shift.date || "N/A"} disabled className="bg-white" />
      </div>
    </div>
  )
}

export default TrialBlockInfo
